import api from './api';

const gameService = {
  // Start authenticated game
  startGame: async () => {
    const response = await api.post('/game/start');
    return response.data;
  },

  // Get round details
  getRound: async (sessionId, roundNumber) => {
    const response = await api.get(`/game/${sessionId}/round/${roundNumber}`);
    return response.data;
  },

  // Submit guess
  submitGuess: async (sessionId, roundNumber, guessData) => {
    const response = await api.post(`/game/${sessionId}/round/${roundNumber}/guess`, guessData);
    return response.data;
  },

  // Get game results
  getResults: async (sessionId) => {
    const response = await api.get(`/game/${sessionId}/results`);
    return response.data;
  },

  // Get user stats
  getStats: async () => {
    const response = await api.get('/game/stats');
    return response.data;
  },
};

export default gameService;
